import { useState } from "react";

const navs = [
  { label: "热度榜", href: "#board" },
  { label: "今日瓜点", href: "#feed" },
  { label: "时间线", href: "#timeline" },
  { label: "话题墙", href: "#topics" },
  { label: "背景解析", href: "#analysis" },
  { label: "完整复盘", href: "#replay" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="wrap flex h-16 items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-google-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="brand-face text-2xl tracking-wide text-foreground-950">
            21<span className="text-primary-500">吃瓜</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navs.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#feed"
            className="hidden items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            <i className="ri-flashlight-line text-base" aria-hidden="true"></i>
            更新入口
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-foreground-800 lg:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navs.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}